import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-column md:flex-row justify-content-between mb-s4" }
const _hoisted_2 = { class: "text-muted mb-s4" }

import { Portfolio } from '@/sdk/entities/portfolio';
import type { Component } from 'vue';
import { computed, onMounted, onUnmounted, ref, markRaw } from 'vue';
import DialogHeader from './common/DialogHeader.vue';
import ControlIcon from '@/components/icon/ControlIcon.vue';
//import TextSwitch from '@/components/switch/TextSwitch.vue';
import { useI18n } from 'vue-i18n';
import { useUtils, isNestedDialogOpen } from '@/composables/utils/useUtils';
import EasyModeAddLiquidityDialog from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/add-liquidity/EasyModeAddLiquidityDialog.vue';
import EasyModeWithdrawDialog from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/withdraw/EasyModeWithdrawDialog.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiquidityManagementDialog',
  props: {
    portfolio: null,
    action: null
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolio: Portfolio;
  action: string;
}





const { t } = useI18n();
const { setMaxDialog } = useUtils();
const { state } = useStore();
const managementMode = ref('easyMode');
const dialogVisible = ref(true);
const onClose = () => {
  dialogVisible.value = false;
  setTimeout(() => emits('close'), 200); // to keep close animation
};
const onConfirm = () => {
  emits('confirm');
};
const getDescription = type => t(`portfolio.${props.action}.${type}Description`);

// TODO включить при появлении expert mode
// const onChangeMode = evt => {
//   managementMode.value = evt ? 'expertMode' : 'easyMode';
// };

const component = markRaw(
  computed(() =>
    props.action === 'addLiquidity' ? EasyModeAddLiquidityDialog : EasyModeWithdrawDialog,
  ) as Component,
);

onMounted(() => setMaxDialog(true));
onUnmounted(() => setMaxDialog(false));

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: dialogVisible.value,
    "show-header": false,
    modal: true,
    "close-on-escape": !_unref(isNestedDialogOpen),
    class: _normalizeClass(`dialog-max ${_unref(state).layout.viewMode} dialog-scrollable`),
    "auto-z-index": false,
    "onUpdate:visible": onClose,
    dismissableMask: ""
  }, {
    default: _withCtx(() => [
      _createVNode(ControlIcon, {
        class: "dialog-header-close",
        name: "close",
        size: "32",
        onClick: onClose
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DialogHeader, {
          action: __props.action,
          "portfolio-name": __props.portfolio.name,
          class: "mb-s3 md:mb-s0"
        }, null, 8, ["action", "portfolio-name"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(state).layout.isDesktop ? 'flex-grow-1 flex flex-column' : 'dialog-content-scrollable')
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(getDescription(managementMode.value)), 1),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
          portfolio: __props.portfolio,
          onClose: onClose,
          onConfirm: onConfirm
        }, null, 40, ["portfolio"]))
      ], 2)
    ]),
    _: 1
  }, 8, ["visible", "close-on-escape", "class"]))
}
}

})